import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBergingTuin = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m26.75 18 9 4.07V36h-18V22z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="M29.75 25.17h-6V36h6z"
    />
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M15.75 11.22V6h-4v1.67L8.75 5l-3 3-.04 28h12.04V13z"
      clipRule="evenodd"
    />
    <path
      fill="#15265A"
      fillRule="evenodd"
      d="m26.743 20.217-10.25 4.55-.406-.914 10.25-4.55z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M6.99 22.35c.845 0 1.53-.716 1.53-1.6s-.685-1.6-1.53-1.6-1.53.716-1.53 1.6.685 1.6 1.53 1.6"
    />
    <path
      fill="#60D15D"
      d="M5.74 24.18c1 0 1.81-.707 1.81-1.58s-.81-1.58-1.81-1.58-1.81.707-1.81 1.58.81 1.58 1.81 1.58"
    />
    <path
      fill="#60D15D"
      d="M6.593 28.172c1.093-.274 1.726-1.504 1.414-2.746-.312-1.243-1.45-2.028-2.543-1.754s-1.726 1.504-1.414 2.747 1.45 2.028 2.543 1.753"
    />
    <path
      fill="#60D15D"
      d="M8.43 29.773c.828-.645 1-1.81.382-2.603-.617-.794-1.789-.915-2.617-.27-.828.644-1 1.81-.382 2.603.617.793 1.789.914 2.617.27M11.733 22.101c.638-.902.3-2.238-.756-2.984-1.055-.746-2.428-.62-3.065.282-.638.902-.3 2.238.756 2.984 1.055.746 2.427.62 3.065-.282"
    />
    <path
      fill="#60D15D"
      d="M8.75 29.97c1.9 0 3.44-2.207 3.44-4.93s-1.54-4.93-3.44-4.93-3.44 2.207-3.44 4.93 1.54 4.93 3.44 4.93"
    />
    <path
      fill="#60D15D"
      d="M12.953 24.396c1.164-.906 1.585-2.311.941-3.14-.644-.828-2.11-.765-3.274.14-1.164.906-1.585 2.31-.94 3.14.643.827 2.11.765 3.273-.14"
    />
    <path
      fill="#60D15D"
      d="M12.666 27.477c.997-.077 1.737-1.014 1.654-2.094s-.959-1.892-1.955-1.815-1.738 1.014-1.654 2.094c.083 1.079.958 1.892 1.955 1.815"
    />
    <path
      fill="#60D15D"
      d="M13.345 28.369c.302-.783-.167-1.694-1.048-2.034s-1.84.019-2.143.802.167 1.694 1.048 2.034 1.84-.019 2.143-.802"
    />
    <path
      fill="#60D15D"
      d="M10.754 30.039c.564-.398.615-1.298.113-2.012-.503-.713-1.367-.97-1.932-.573-.565.398-.615 1.299-.113 2.012.503.714 1.367.97 1.932.573"
    />
    <path
      fill="#60D15D"
      d="M9.25 28h-1v8h1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBergingTuin);

export default ForwardRef;
